<template>
	<div>
		<form v-on:submit.prevent id="registrationForm">
			<account-registration :account="account" :additionalQuestions="additionalQuestions" :crew="mycrew"></account-registration>
			<question-list :questions="questionnaire.questionList" v-if="elementsLoaded" ref="questionList" :crew="mycrew"></question-list>
			<friendly-captcha :sitekey="siteKey" v-on:done="frcDone" v-on:error="frcError"></friendly-captcha>
			<div id="errorbox" class="errorBox" style="display:none"></div>
			<div style="padding-top:20px">
				<button v-on:click="saveRegistration" class="btn btn-white teaserButton" style="width:100%" v-if="mycrew == 'inStyle'">Join now</button>
				<button v-on:click="saveRegistration" class="btn btn-white teaserButton" style="width:100%" v-else>SPEICHERN</button>
			</div>
		</form>
		<div id="registrationSuccess" style="display:none">
			Vielen Dank für deine Registrierung. Wir haben dir eine E-Mail an {{account.email}} geschickt. Bitte klicke den darin enthaltenen Link, 
			um deine Registrierung vollständig abzuschließen.
		</div>
		<div id="registrationSuccessInStyle" style="display:none">
			<br>
			<br>
			Vielen Dank für die Übermittlung deiner Daten und dein Interesse an der InStyle Crew. Wir haben dir
			eine E-Mail an {{account.email}} gesendet. Bitte klicke auf den darin enthaltenen Link, um deine
			Identität zu bestätigen und die Anmeldung abzuschließen
		</div>
	</div>
</template>

<script>
import QuestionList from './QuestionList.vue'
import AccountRegistration from './AccountRegistration.vue'
import FriendlyCaptcha from './FriendlyCaptcha.vue';

export default {
	name: 'questionnaire',
	props: {
		questionnaire: Object,
		recaptchaSiteKey: {
			type: String,
			required: false,
			default: null
		},
		crew: {
			type: String,
			required: false,
			default: null
		}
	},
	created: function() {
		//The questionaire component seems modify the properties so we have to save the key
		this.siteKey = this.recaptchaSiteKey;
		this.mycrew = this.crew;
		let self = this;
		if (window.consent && window.consent['consent_5e716fc09a0b5040d575080f'] === true) {
		    self.fbqReady = true;
		} else {
			document.addEventListener("fbqReady", function(e) {
				self.fbqReady = true;
			});
		}
	},	
	data: function () {
		return {
			account: {
				username: this.crew ? "@" : "",
				email: "",
				password: "",
				repeatedPassword: "",
				shapeId: { name: "byl" }
			},
			additionalQuestions: {
				instagram: "",
				tiktok: ""
			},
			elementsLoaded: false,
			siteKey: null,
			frcSolution: null,
			fbqReady: false
		}
	},
	methods: {
		validate() {
            return this.$refs.questionList.onValidate();
        },
		saveRegistration() {
			//validate
			let hasErrors = false;
			hasErrors = this.validate();
			
			//wenn wir schon dabei sind.....this.username
			if(this.account.username.length===0){
				jQuery('#usernameError').show();
				hasErrors = true;
			}
			else{
				jQuery('#usernameError').hide();
			}
			if(this.account.email.length===0){
				jQuery('#emailError').show();
				hasErrors = true;
			}
			else{
				jQuery('#emailError').hide();
			}
			if(this.account.password.length===0 || this.account.password !== this.account.repeatedPassword){
				jQuery('#password1Error').show();
				hasErrors = true;
			}
			else{
				jQuery('#password1Error').hide();
			}
			if(this.account.repeatedPassword.length===0 || this.account.repeatedPassword !== this.account.password){
				jQuery('#password2Error').show();
				hasErrors = true;
			}
			else{
				jQuery('#password2Error').hide();
			}
			
			//additionalQuestions in AccountRegistration
			if(this.additionalQuestions.instagram.length===0 && this.additionalQuestions.tiktok.length===0) {
				jQuery('#instagramError').show();
				jQuery('#tiktokError').show();
				hasErrors = true;
			} else {
				jQuery('#instagramError').hide();
				jQuery('#tiktokError').hide();
			}
				
			if(this.additionalQuestions.instagram.length > 0) {
		        if(/^(http|https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(this.additionalQuestions.instagram)) {
		        	jQuery('#instagramErrorUrl').hide();
		        } else {
			        jQuery('#instagramErrorUrl').show();
					hasErrors = true;
			    }
		    } else {
				jQuery('#instagramErrorUrl').hide();
			}
			
			if(this.additionalQuestions.tiktok.length > 0) {
				if(/^(http|https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(this.additionalQuestions.tiktok)) {
		        	jQuery('#tiktokErrorUrl').hide();
		        } else {
			        jQuery('#tiktokErrorUrl').show();
					hasErrors = true;
			    }
			} else {
				jQuery('#tiktokErrorUrl').hide();
			}

			let errorBox = jQuery('#errorbox');
			errorBox.html("");
			if (!this.frcSolution) {
				errorBox.append('<p>Bitte löse das Captcha</p>');
				hasErrors = true;
			}

			if (hasErrors) {
				errorBox.append('<p>Bitte berichtige die markierten Felder</p>')
				console.log('There are errors');
				jQuery("#errorbox").show();
				return;
			}
			var answers = [];
			var self = this;
			this.questionnaire.questionList.forEach(function(item) {
				if (item.propertyInfo.type.kind == 'MATRIX') {
					var values = [];
					for (var key in item.answer.value) {
						var value = item.answer.value[key];
						if (value) {
							values.push(value);
						}
					}
					var answer = {};
					answer.questionId = item.answer.questionId;
					answer.type = item.answer.type;
					answer.value = values;
					answer.visible = item.answer.visible;
					answers.push(answer);
				} else {
					if(item.propertyInfo.key.value === 'basis.instagram.url') {
						item.answer.value = self.additionalQuestions.instagram;
						item.dependenceExpression = "";
					} else if(item.propertyInfo.key.value === 'basis.tiktok.url') {
						item.answer.value = self.additionalQuestions.tiktok;
						item.dependenceExpression = "";
					}
					answers.push(item.answer);
				}
			});
			var registration = {};
			registration.answers = answers;
			registration.account = this.account;
			registration.captcha = this.frcSolution;
			if(this.mycrew){
				registration.crew = this.mycrew;
			}
			jQuery.ajax({
				url: '/saveRegistration',
				type: 'POST',
				dataType: "json",
				data: JSON.stringify(registration),
				contentType: "application/json; charset=utf-8",
				success: function(data) {
					console.debug("Success - " + JSON.stringify(data));
					jQuery('#registrationForm').hide();
					if(registration.crew ==='inStyle'){
						jQuery('#registrationSuccessInStyle').show();
					}
					else{
						jQuery('#registrationSuccess').show();
						window.console.log("1");
						if(self.fbqReady) {
							fbq('track', 'CompleteRegistration');
						}
					}
				},
				error: function(error) {
					console.debug(JSON.stringify(error));
					jQuery('#errorbox').empty();
					let errorCodes = error.responseJSON.whathappend;
					for (let i = 0; i < errorCodes.length; i++) {
						jQuery('#errorbox').append('<p>' + errorCodes[i][0] + '</p>');
					}
					jQuery("#errorbox").show();
				}
			});
		},
		onElementsLoaded: function() {
			this.$nextTick(function() {
				this.questionnaire.questionList.forEach(function(item) {
					if(item.propertyInfo.key.value === 'basis.instagram.url' || item.propertyInfo.key.value === 'basis.tiktok.url') {
						item.dependenceExpression = "false";
					}
				});
				this.elementsLoaded = true;
			});
		},
		frcDone: function(solution) {
			this.frcSolution =  solution;
		},
		frcError: function(error) {
			this.frcSolution = null;
			console.log("captcha error: " + error);
		}
	},
	components: { QuestionList, AccountRegistration, FriendlyCaptcha }
}
</script>



// WEBPACK FOOTER //
// Registration.vue?5e6afef2